// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable[data-v-771e8f65] {\n  border: 1px solid black;\n  border-collapse: collapse;\n  width: 100%;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
